const { Marker } =
    typeof window !== "undefined" ? require("react-leaflet") : {};

export const TaskMarker = Marker;
export default TaskMarker;
